import './damasio_logos.erb';
import './direcao_logos.erb';
import './images/damasio.svg';
import './index.scss';
import 'components/experiment_benefits';
import 'components/header_mobile_menu';
import 'components/header_mobile_user_menu';
import 'components/user/avatar';
import 'images/tracks/direcao-icon.svg';
import 'images/tracks/direcao.svg';

(function ($) {
  function trackingEventSearchHeader(props) {
    UserTracker.emit('event', {
      eventName: 'global search',
      data: {
        request_path: window.location.pathname,
        ...props
      }
    });
  }

  function handleLinkClick() {
    $('a[data-tracking-event]').on('click', function () {
      const trackingData = $(this).data('tracking-event');

      if (trackingData && trackingData?.data) {
        UserTracker.emit('event', {
          eventName: trackingData.eventName,
          data: {
            element_clicked: trackingData.data.element_clicked
          }
        });
      }
    });
  }

  function init() {
    handleLinkClick();

    function handleOutsideClick(event, $element, $Toggle, $ToggleInput) {
      if (
        $(event.target).closest($element).length === 0 &&
        $(event.target).closest($Toggle).length === 0 &&
        $(event.target).closest($ToggleInput).length === 0 &&
        $element.length &&
        !$element.is(':hover')
      ) {
        $ToggleInput.prop('checked', false);
      }
    }

    $(document)
      .off('click.header')
      .on('click.header', event => {
        const $segmentsMenu = $('#js-segments-menu');
        const $segmentsMenuToggle = $('.js-segments-menu-toggle');
        const $segmentsMenuToggleInput = $('#segments-toggle-input');

        const $search = $('#js-header-search');
        const $searchToggle = $('.js-header-search-toggle');
        const $searchToggleInput = $('#search-toggle-input');

        handleOutsideClick(
          event,
          $segmentsMenu,
          $segmentsMenuToggle,
          $segmentsMenuToggleInput
        );
        handleOutsideClick(event, $search, $searchToggle, $searchToggleInput);
      });

    // event new menu
    const $cta = $('#playgroundCtaHeader');
    const $eliteCta = $('#eliteCtaHeader');
    const $formSearch = $('#js-header-search');

    // event search
    $formSearch.on('submit', e => {
      const formData = new FormData(e.target);
      const formProps = Object.fromEntries(formData);

      const onlyQuestion = JSON.parse(formProps?.only_question ?? 'false');

      if ($formSearch.data('triggerEvent')) {
        trackingEventSearchHeader({
          query: `${onlyQuestion ? 'questoes: ' : ''}${formProps.q}`
        });
      }

      // baseline search submitted
      UserTracker.emit('event', {
        eventName: 'global search',
        data: {
          query: formProps.q,
          'request path': window.location.pathname,
          'referral path': document?.referrer
            ? new URL(document.referrer).pathname
            : '',
          'search type': $formSearch?.data?.('originSearch') ?? 'odin',
          'source project': 'odin'
        }
      });
    });

    // show checkbox
    $formSearch.find('#search-header').on('focus', () => {
      $('label[for="only_question"]').show();
    });

    // click in Mesa de estudos button onmenu
    $cta.on('click', () => {
      UserTracker.emit('event', {
        eventName: 'mesa button clicked',
        data: {
          portal_source: 'menu'
        }
      });
    });

    // click in Elite button on menu
    $eliteCta.on('click', () => {
      UserTracker.emit('event', {
        eventName: 'elite button clicked',
        data: {
          'click source': 'portal - menu'
        }
      });
    });
  }

  $(document).on('turbolinks:load', () => {
    init();
  });
})(jQuery);
